"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var pages = _interopRequireWildcard(require("./domains/pages"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var _pages$actions = pages.actions,
  getPageHTML = _pages$actions.getPageHTML,
  getPageMarkdown = _pages$actions.getPageMarkdown,
  updatePageEditorState = _pages$actions.updatePageEditorState,
  savePage = _pages$actions.savePage,
  discardPageChanges = _pages$actions.discardChanges,
  createPage = _pages$actions.createPage,
  deletePage = _pages$actions.deletePage,
  renamePage = _pages$actions.renamePage;
var _pages$selectors = pages.selectors,
  selectPageEditorState = _pages$selectors.pageEditorState,
  selectDraftOrPublishedPage = _pages$selectors.draftOrPublishedPage,
  selectPage = _pages$selectors.page,
  selectPages = _pages$selectors.pages,
  selectPageMarkdown = _pages$selectors.pageMarkdown,
  selectPageHTML = _pages$selectors.pageHTML;
var actions = {
  getPageHTML: getPageHTML,
  getPageMarkdown: getPageMarkdown,
  updatePageEditorState: updatePageEditorState,
  savePage: savePage,
  discardPageChanges: discardPageChanges,
  createPage: createPage,
  deletePage: deletePage,
  renamePage: renamePage
};
var selectors = {
  selectDraftOrPublishedPage: selectDraftOrPublishedPage,
  selectPageEditorState: selectPageEditorState,
  selectPage: selectPage,
  selectPages: selectPages,
  selectPageMarkdown: selectPageMarkdown,
  selectPageHTML: selectPageHTML
};
var _default = exports.default = {
  actions: actions,
  selectors: selectors
};
//# sourceMappingURL=pages.js.map